import { createContext, useContext, useState } from "react";

export const UserContext = createContext(null);

export function UserProvider({ children }) {
  // One unified user object
  const [user, setUser] = useState({
    user_id: null,
    threadId: 0,
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

// handy hook
export function useUser() {
  return useContext(UserContext);
}